// extracted by mini-css-extract-plugin
export default {"root":"ySZ-A","createPostButton":"_2dkTF"};